export default __webpack_public_path__ + "static/media/roomHighlight.8d91b291.jpg";